import { render, staticRenderFns } from "./campaigns.vue?vue&type=template&id=66575847&"
import script from "./campaigns.vue?vue&type=script&lang=js&"
export * from "./campaigns.vue?vue&type=script&lang=js&"
import style0 from "./campaigns.vue?vue&type=style&index=0&id=66575847&lang=scss&"
import style1 from "./campaigns.vue?vue&type=style&index=1&id=66575847&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66575847')) {
      api.createRecord('66575847', component.options)
    } else {
      api.reload('66575847', component.options)
    }
    module.hot.accept("./campaigns.vue?vue&type=template&id=66575847&", function () {
      api.rerender('66575847', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/campaign/campaigns.vue"
export default component.exports